import axiosInstance from "../utils/requestInstance";
import environment from "../enviroment";
import { toast } from "react-toastify";
const API_URL = environment.endPoint;

const user = [];

const User = {

  async AcceptBid(id) {
    try {
      const response = await axiosInstance.post(`/bid/acceptBid/${id}`, {});
      const data = response.data.result;
      toast.success(data.message);
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async getAllUser(payload) {
    try {
      const response = await axiosInstance.get(`/bid/getAllRequirment`, {
        params: payload,
      });
      let data = response.data.result;
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async getAllBidByRequirementId({ id, param = {} }) {
    try {
      const response = await axiosInstance.get(
        `/bid/getAllBidByRequirement/${id}`,
        {
          params: param,
        }
      );
      let data = response.data.result;
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async Create(payload) {
    try {
      const response = await axiosInstance.post(`/bid/create`, payload);
      const data = response.data.result;
      toast.success(data.message);
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async CreateBid(payload) {
    try {
      const response = await axiosInstance.post(`/bid/createBid`, payload);
      const data = response.data.result;
      toast.success(data.message);
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async getById(payload) {
    try {
      const response = await axiosInstance.get(
        `/bid/getRequirmentById/${payload}`
      );
      return response.data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async updateById(payload, id) {
    try {
      const response = await axiosInstance.put(`/bid/update/${id}`, payload);
      let data = response.data.result;
      toast.success(data.message);
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },

  async delete(id) {
    try {
      const response = await axiosInstance.delete(`/user/delete/${id}`);
      let data = response.data.result;
      toast.success(data.message);
      return data;
    } catch (error) {
      toast.error(
        error.response.data.message
          ? error.response.data.message
          : "Internal Server Error"
      );
      console.log(error);
    }
  },
};

export default User;
